import { CordovaPlugins } from '../CordovaPlugins';
import { isWeb } from './is';
import { showSuccessMessage } from './notifications';

type DebuggingFlags =
    | 'disable_background_uploading'
    | 'fail_file_uploads'
    | 'disable_template_validation'
    | 'css_native'
    | 'pending';

export const isReleaseBuild = (): boolean => {
    if (isWeb()) {
        return process.env.DEPLOY_ENV === 'production';
    }

    return !CordovaPlugins().BuildInfo.debug;
};

export const isDebuggingEnabled = (): boolean => {
    if (localStorage.getItem('debug_enabled') !== null) {
        return JSON.parse(localStorage.getItem('debug_enabled'));
    }

    if (process.env.DEPLOY_ENV !== 'production') {
        return true;
    }

    return !isReleaseBuild();
};

export const enableDebugging = () => {
    localStorage.setItem('debug_enabled', 'true');
};

export const clearDebuggingFlags = () => {
    localStorage.removeItem('debug_flags');
};

export const disableDebugging = () => {
    clearDebuggingFlags();
    localStorage.setItem('debug_enabled', 'false');
};

export const setDebuggingFlag = (flag: DebuggingFlags, value: boolean) => {
    const flags = JSON.parse(localStorage.getItem('debug_flags')) || {};
    flags[flag] = value;
    localStorage.setItem('debug_flags', JSON.stringify(flags));
};

export const getDebuggingFlag = (flag: DebuggingFlags): boolean => {
    try {
        // safest to use try/catch here so any problems with localStorage don't mess with production behavior
        const flags = JSON.parse(localStorage.getItem('debug_flags')) || {};
        return flags[flag];
    } catch (e) {
        return false;
    }
};

export const enableWeinreRemoteDebug = () => {
    if (!$f.active_user.is_logged_in()) {
        return;
    }

    (function (e) {
        e.setAttribute('src', `https://mobiledebug.zenput.com/target/target-script-min.js#${$f.active_user.get('id')}`);
        document.getElementsByTagName('body')[0].appendChild(e);
    })(document.createElement('script'));
    void 0;
    showSuccessMessage('Remote debugging started.');
};
